import Controller from '@ember/controller';
import { service } from '@ember/service';

import type FlashMessageService from 'ember-cli-flash/services/flash-messages';

// eslint-disable-next-line ember/no-controllers
export default class Application extends Controller {
  @service declare flashMessages: FlashMessageService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @service declare headData: any;
}

declare module '@ember/controller' {
  interface Registry {
    application: Application;
  }
}
